import { CONFIG } from '../config.js';

const C = CONFIG.COLORS;

export class VirtualJoystick {
  constructor(scene) {
    this.scene = scene;
    this.radius = 56;
    this.baseX = 0;
    this.baseY = 0;
    this.activePointerId = null;
    this.dx = 0;
    this.dy = 0;

    this.bg = scene.add
      .circle(0, 0, this.radius, 0x000000, 0.35)
      .setStrokeStyle(2, 0xffffff, 0.45)
      .setVisible(false)
      .setDepth(60);
    this.knob = scene.add
      .circle(0, 0, this.radius * 0.45, C.UI_PRIMARY, 0.75)
      .setStrokeStyle(2, 0xffffff, 0.7)
      .setVisible(false)
      .setDepth(61);

    const dev = scene.sys.game.device;
    this.disabled = !(dev.input.touch || dev.os.iOS || dev.os.android);

    if (!this.disabled) {
      scene.input.on('pointerdown', this.onPointerDown, this);
      scene.input.on('pointermove', this.onPointerMove, this);
      scene.input.on('pointerup', this.onPointerUp, this);
      scene.input.on('pointerupoutside', this.onPointerUp, this);
    }
  }

  isInActiveZone(pointer) {
    if (pointer.y >= CONFIG.PLAY_AREA_BOTTOM - 8) return false;
    if (pointer.y <= CONFIG.PLAY_AREA_TOP - 8) return false;
    return true;
  }

  onPointerDown(pointer) {
    if (this.disabled || this.activePointerId !== null) return;
    if (!this.isInActiveZone(pointer)) return;
    this.activePointerId = pointer.id;
    this.baseX = pointer.x;
    this.baseY = pointer.y;
    this.bg.setPosition(this.baseX, this.baseY).setVisible(true);
    this.knob.setPosition(this.baseX, this.baseY).setVisible(true);
    this.updateFromPointer(pointer);
  }

  onPointerMove(pointer) {
    if (this.disabled) return;
    if (this.activePointerId !== pointer.id) return;
    this.updateFromPointer(pointer);
  }

  onPointerUp(pointer) {
    if (this.disabled) return;
    if (this.activePointerId !== pointer.id) return;
    this.activePointerId = null;
    this.dx = 0;
    this.dy = 0;
    this.bg.setVisible(false);
    this.knob.setVisible(false);
  }

  updateFromPointer(pointer) {
    const dx = pointer.x - this.baseX;
    const dy = pointer.y - this.baseY;
    const d = Math.hypot(dx, dy);
    let nx = dx;
    let ny = dy;
    if (d > this.radius) {
      nx = (dx / d) * this.radius;
      ny = (dy / d) * this.radius;
    }
    this.knob.setPosition(this.baseX + nx, this.baseY + ny);
    this.dx = nx / this.radius;
    this.dy = ny / this.radius;
  }

  getVector() {
    return { x: this.dx, y: this.dy };
  }
}
